import {
  deliveryFieldset,
  directDebitFieldset,
  sortCodeFieldset,
} from './../components/order-form/order-form-config';
import { Contact } from '@dgx-pr-spa/shared/util';
import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { Address } from '@dgx-pr-spa/shared/util';
import {
  DeliveryForm,
  DirectDebitForm,
  FormStep,
} from '@dgx-pr-spa/shared/util';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Injectable } from '@angular/core';
import { DirectDebitControls } from '@dgx-pr-spa/shared/util';
import {
  DynamicFormbuilderService,
  FormGroupTyped,
} from '@domgen/dgx-fe-dynamic-form-builder';

interface DeliveryFormType {
  firstAvailableDate: boolean;
  expectedDate: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  postCode: string;
  countryCode: string;
  email: string;
  mobile: string;
  telephone: string;
  isTelephoneOpen: boolean;
  accessDifficulties: string;
  accessInfo: string;
  stairs: string;
  additionalInfo: string;
}
@Injectable({
  providedIn: 'root',
})
export class FormService {
  deliveryFieldset = deliveryFieldset;
  directDebitFieldset = directDebitFieldset;
  sortCodeFieldset = sortCodeFieldset;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private dfb: DynamicFormbuilderService
  ) {}

  form: UntypedFormGroup;

  createForm() {
    return this.fb.group({
      [FormStep.Delivery]: this.deliveryForm(),
      [FormStep.DirectDebit]: this.directDebitForm(),
      [FormStep.UpfrontPayment]: null,
    });
  }

  deliveryForm() {
    return <FormGroupTyped<DeliveryFormType>>(
      this.dfb.generateFormGroup(this.deliveryFieldset)
    );
  }
  directDebitForm(): UntypedFormGroup {
    const sortCode = this.dfb.generateFormGroup(this.sortCodeFieldset);
    const ddForm = this.dfb.generateFormGroup(this.directDebitFieldset);
    ddForm.addControl('sortCode', sortCode);
    return ddForm;
  }

  defaultDeliveryData(deliveryAddress: Address, contact: Contact) {
    return {
      addressLine1: deliveryAddress?.address_line_1,
      addressLine2: deliveryAddress?.address_line_2,
      addressLine3: deliveryAddress?.address_line_3,
      addressLine4: deliveryAddress?.address_line_4,
      postCode: deliveryAddress?.postal_code,
      countryCode: deliveryAddress?.country_code,
      email: contact?.contact_email ? contact.contact_email.toLowerCase() : '',
      mobile: contact?.mobile_tel || '',
      telephone: contact?.home_tel || '',
    } as DeliveryForm;
  }

  defaultDirectDebitData(itemOffer: ItemOffer) {
    return {
      monthlyPayment: itemOffer.subsequentPayment,
    } as DirectDebitForm;
  }
}
